import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar,FormControl,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'

//http://react-day-picker.js.org/examples/?yearNavigation
const TABLE_LIST = [
  {id:'OT_AFTERWORK_FOR_DAILY',title:'OT หลังเลิกงานพนักงานรายวัน ใช้ตัวคูณ',value:''},
  {id:'OT_AFTERWORK_FOR_MONTHLY',title:'OT หลังเลิกงานพนักงานประจำ ใช้ตัวคูณ',value:''},
  {id:'OT_HOLIDAY_FOR_DAILY',title:'OT วันหยุด พนักงานรายวัน ใช้ตัวคูณ',value:''},
  {id:'OT_HOLIDAY_FOR_MONTHLY',title:'OT วันหยุด พนักงานประจำ ใช้ตัวคูณ',value:''}
]

class SlipConfigPopup extends Component {
  constructor(...args){
    super(...args)
    let dt = new Date();
    let year = dt.getFullYear()*1+543
    this.state = {loading:true,statusText:'',tableList:TABLE_LIST}
    
    
  }

  loadConfig(){
    
    let that = this
    HrStore.loadSlipConfig(function(result){
      let tableList = TABLE_LIST.map((item,index)=>{
        item.value = result.data[item.id]
        return item
      })
      
      that.setState({loading:false,tableList:tableList})
      
    },function(){

    })
  }


    onHide(){
      this.props.onHide();
    }

   

    onSaveClick(){
      let {tableList,statusText} = this.state
      let that = this
      let slipConfig =  {}
      TABLE_LIST.map((item,index)=>{
        slipConfig[item.id] = item.value
        return item
      })
      HrStore.saveSlipConfig(slipConfig,function(result){
        if(result.status==='OK'){
          that.setState({statusText:'บันทึกเรียบร้อย'})
          setTimeout(function(){ that.setState({statusText:''}) }, 3000);
        }
      },function(){

      })
    }

    onValueChange(index,e){
      let {tableList} = this.state
      tableList[index].value = e.target.value
      this.setState({tableList:tableList})
    }

    
    

    renderTableData(){
      let {tableList} = this.state
      return tableList.map((item,index)=>(
        <tr key={index} className="data-row">
            <td className="data-column ">
              <ControlLabel >{item.title}</ControlLabel>
            </td>
            <td className="data-column">
                <FormControl value={item.value}  className='text-center'
                onChange={this.onValueChange.bind(this,index)}/>
            </td>
        </tr>
      ))
    }

    renderConfigForm(){
      let {year,loading} = this.state
      return (
        <div className="box box-default " id='box-holiday'>
            <div className="box-body">
                
                <table className="table table-responsive table-bordered-solid">
                    <thead>
                        <tr>
                            <th >รายการ</th>
                            <th>รายละเอียด</th>
                        </tr>
                    </thead>
                    <tbody>
                      {this.renderTableData()}
                    </tbody>

                </table>                
            </div>
            <div className="overlay" style={{display:(loading?'block':'none')}}>
              <i className="fa fa-refresh fa-spin"></i>
            </div>
            <div className="box-footer">
                <div className=" pull-right">
                  <ButtonToolbar>
                    <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}><FontAwesome name="save"/>&nbsp;บันทึก</Button>
                    <Button bsStyle="default" onClick={this.props.onHide}><FontAwesome name="close"/>&nbsp;ปิดหน้าต่าง</Button>
                  </ButtonToolbar>
                </div>
                <div className='pull-left' style={{lineHeight:'36px'}}>
                  <ControlLabel> {this.state.statusText} </ControlLabel>
                </div>  
            </div>
                      
        </div>
      )
    }
    render(){

      let label  = 'ตั้งค่า OT '
      return (
        <Modal show={this.props.show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderConfigForm()}
          </Modal.Body>
       </Modal>
      )
    }
}

export default SlipConfigPopup



// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipConfigPopup.js